export default __webpack_public_path__ + "static/media/mountains.21e70a8c.png";